import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=46f4cdc1&"
import script from "./MainModal.vue?vue&type=script&lang=js&"
export * from "./MainModal.vue?vue&type=script&lang=js&"
import style0 from "./MainModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports